import { apiFetch, FormFileUpload, FormInput, NotesBanner, Spinner } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, FormGroup, Label } from 'reactstrap';
import QuoteAcceptanceInformation from './quoteAcceptanceInformation';

export default class QuoteAcceptanceInformationFormComponent extends React.Component {
  static propTypes = {
    quoteId: PropTypes.string.isRequired,
    quoteAcceptanceInformation: PropTypes.instanceOf(QuoteAcceptanceInformation)
      .isRequired,
    onQuoteAcceptanceInformationUpdated: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      originalFileKey: this.props.quoteAcceptanceInformation.fileKey,
      downloading: false,
    };
  }

  updateQuoteAcceptanceInformation = (updateObject) =>
    this.props.onQuoteAcceptanceInformationUpdated(
      new QuoteAcceptanceInformation({
        ...this.props.quoteAcceptanceInformation,
        ...updateObject,
      })
    );

  downloadDocument = async (quoteId) => {
    this.setState({ downloading: true });
    const response = await apiFetch(`quotes/${quoteId}/purchase-order`);
    window.location = response.url;
    this.setState({ downloading: false });
  };

  render() {
    const { quoteAcceptanceInformation } = this.props;
    return (
      <div>
        <FormGroup>
          <FormInput
            required={true}
            id="poNumber"
            label="PO Number"
            placeholder="Enter the PO number"
            value={quoteAcceptanceInformation.poNumber}
            onChange={(e) =>
              this.updateQuoteAcceptanceInformation({
                poNumber: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup>
          <Label className="form-label">PO Document</Label>
          {quoteAcceptanceInformation.fileKey &&
            quoteAcceptanceInformation.fileKey ===
            this.state.originalFileKey && (
              <div>
                <Button
                  color="outline-primary"
                  className="btn-sm"
                  onClick={() => this.downloadDocument(this.props.quoteId)}
                >
                  {this.state.downloading && <span>Downloading...</span>}
                  {!this.state.downloading && (
                    <span>
                      Download document <span className="fa fa-download" />
                    </span>
                  )}
                  <Spinner show={this.state.downloading} />
                </Button>
                <button
                  className="btn btn-sm btn-danger ms-2"
                  type="button"
                  onClick={() =>
                    this.updateQuoteAcceptanceInformation({
                      fileKey: '',
                      fileName: '',
                    })
                  }
                >
                  Remove or change document
                </button>
              </div>
            )}
          {(!quoteAcceptanceInformation.fileKey ||
            quoteAcceptanceInformation.fileKey !==
            this.state.originalFileKey) && (
              <FormFileUpload
                hideUploadAfterFile={true}
                onFileUploaded={(fileInfo) =>
                  this.updateQuoteAcceptanceInformation({
                    fileKey: fileInfo.key,
                    fileName: fileInfo.name,
                  })
                }
              >
                {quoteAcceptanceInformation.fileName}
              </FormFileUpload>
            )}
        </FormGroup>
        <FormGroup>
          <FormInput
            id="notes"
            type="textarea"
            label="Notes"
            placeholder="Enter some notes"
            value={quoteAcceptanceInformation.notes}
            onChange={(e) =>
              this.updateQuoteAcceptanceInformation({ notes: e.target.value })
            }
          />
          { quoteAcceptanceInformation.notes.trim() && (
            <NotesBanner />
          )}
        </FormGroup>
      </div>
    );
  }
}
